var countries = require('json!../../../../../config/countries.json');
var editions = require('json!../../../../../config/editions.json');

var userpassword = null;

angular.module('account.settings', [
  'resources.User',
  'ui.bootstrap',
  'ngFileUpload',
  'services.formErrors',
	'security',
	'services.localizedMessages'
])


.config(["$stateProvider", function($stateProvider){
  $stateProvider
    .state('account.settings', {
      url: '/settings',
      title: 'Account Settings',
      views: {
        'main@': {
          template: require('./account-settings.tpl.html'),
          controller: 'AccountSettingsCtrl'
        }
      }
      ,resolve: {
        user: ["User", "$location", "$q", function (User, $location, $q) {
          return User.current().$promise.then(function (user) {
            if (!user._id) {
              $location.path('/login');
              return $q.reject('unauthorized');
            }
            return user;
          });
        }],
      }
    });
}])

.controller('AccountSettingsCtrl', ["$scope", "User", "user", "formErrors", "$uibModal", "growl", "Upload", "APP_IMG_URLS", "localizedMessages", function ($scope, User, user, formErrors, $uibModal, growl, Upload, APP_IMG_URLS, localizedMessages) {
  $scope.dataLoaded = true;
	$scope.localizedMessages = localizedMessages;
  $scope.user = user;
  userpassword = user.password;
  $scope.imgUrl = APP_IMG_URLS.base;
  // console.log("----------->1>>>>>", user.account);
  $scope.countries = [];
  _.forIn(countries, function (value, key) {
    $scope.countries.push({
      _id: key,
      name: value
    });
  });
  $scope.editions = [];
  _.forIn(editions, function (value, key) {
    $scope.editions.push({
      _id: key,
      name: value
    });
  });
  $scope.user.account.country = _.find($scope.countries, {_id: user.account.country});
  $scope.user.account.editions = [];
  user.account.groups.forEach(function (group) {
    if (editions[group._id]) {
      $scope.user.account.editions.push({
        _id: group._id,
        name: editions[group._id]
      });
    }
  });

  $scope.submit = function (data) {
    $scope.dataLoaded = false;

    // console.log('>>>', data);
    var data = _.pick(angular.copy(data), ['_id', 'account', 'username', 'email', 'twitter', 'facebook', 'google', 'is_active']);
    var groups = _.map(data.account.groups, '_id').filter(function (id) {
      return !editions[id];
    });
    data.password = userpassword;
    // console.log("----------->2>>>>>"+userpassword);
    data.account.country = data.account.country._id;
    data.account.groups = groups.concat(_.map(data.account.editions, '_id'));
    delete data.account['editions'];

    if( ! data.full ) {
      data.full = ((data.first || '') + ' ' + (data.last || '')).trim();
    }
    // console.log( '>>>', data );
    User.updateAccount(data, function (result) {
      // $scope.user = result;
      $scope.dataLoaded = true;
      growl.info('Changes saved!');
    }, formErrors.growlErrors);
  };

  $scope.changePassword = function () {
    var modalInstance = $uibModal.open({
      animation: true,
      backdrop: true,
      templateUrl: 'changePassword.tpl.html',
      controller: 'ChangePasswordCtrl'
    })
  };

  $scope.$watch('file', function (file) {
    if (!file) return;
    $scope.upload(file);
  });

  // upload on file select or drop
  $scope.upload1 = function (file) {
    $scope.uploading = true;
    $scope.user.account.picture = file;
    Upload.upload({
      url: '/api/articles/upload',
      data: {file: file}
    }).then(function (resp) {
      $scope.uploading = false;
      $scope.user.account.picture = resp.data.filename;
      $scope.data.image = resp.data.filename;
    }, function (resp) {
      $scope.uploading = false;
      $scope.thumbnail = null;
      console.log('Error status: ' + resp.status);
    }, function (evt) {
      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
    });
  };


  $scope.$watch('file1', function (file) {
    if (!file) return;
    $scope.upload1(file);
  });

  $scope.generateThumb = function(file, rejFile){
    if(file === null && rejFile === undefined){
      growl.info('Max image size is 10MB!',3);

    }
  }

  // upload on file select or drop
  $scope.upload = function (file) {
    console.log(file.size );
      $scope.uploading = true;
      $scope.user.account.avatar = file;
      Upload.upload({
        url: '/api/articles/upload',
        data: {file: file}
      }).then(function (resp) {
        $scope.uploading = false;
        $scope.user.account.avatar = resp.data.filename;
        $scope.data.image = resp.data.filename;
      }, function (resp) {
        $scope.uploading = false;
        $scope.thumbnail = null;
        console.log('Error status: ' + resp.status);
      }, function (evt) {
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
        console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
      });

  };

  $scope.changeLogin = function () {
    var modalInstance = $uibModal.open({
      animation: true,
      backdrop: true,
      templateUrl: 'changeLogin.tpl.html',
      controller: 'ChangeLoginCtrl',
      resolve: {
        data: $scope.user
      }
    })
  };
}])

.controller('ChangePasswordCtrl', ["$scope", "$uibModalInstance", "User", "formErrors", "growl", "security", function ($scope, $uibModalInstance, User,  formErrors, growl, security ) {
  $scope.submit = function (data) {
    // console.log('>>> user:', userpassword);
    // User.current().$promise.then(function (user) {
    //   console.log( '>>>', user );
    // });

    var d = {
      oldPassword: userpassword,
      password: security.createHash(data.password),
      confirm_password: security.createHash(data.confirm_password)
    };
    User.changePassword(d, function (result) {
      $scope.data = {};
      growl.info('Changes saved!');
      $uibModalInstance.close();
    }, formErrors.growlErrors);
  };
}])

.controller('ChangeLoginCtrl', ["$scope", "$uibModalInstance", "User", "formErrors", "growl", "data", function ($scope, $uibModalInstance, User, formErrors, growl, data) {
  $scope.data = {
    username: data.username,
    email: data.email
  };

  $scope.submit = function (data) {
    User.changeLogin(data, function (result) {
      $scope.data = {};
      growl.info('Changes saved!');
      $uibModalInstance.close();
    }, formErrors.growlErrors);
  };
}])



// WEBPACK FOOTER //
// ./client/src/app/account/settings/account-settings.js